import InventoryMultiPlan from './InventoryMultiPlan'

export default InventoryMultiPlan